import { createAsyncThunk } from '@reduxjs/toolkit';

import { paths } from 'src/routes/routes/paths';

import { del, get, put, post } from './http';
import { activeSnack } from '../store/common';

export const createProFolio = createAsyncThunk(
  'portfolio/create',
  async ({ state, dispatch, router }) => {
    try {
      const URL = `/portfolio/admin/new`;
      const response = await post(URL, state);
      if (response) {
        router.push({
          pathname: paths.dashboard.portfolios,
          query: {},
        });
        dispatch(activeSnack({ type: 'success', message: 'ProFolio created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllProFolios = createAsyncThunk(
  'portfolio/list',
  async ({ page, search, dispatch, limit, project, date, sort }) => {
    try {
      const response = await get(
        `/PortFolio/admin/all?page=${page && page}&search=${search && search}&limit=${limit || 5}&dateFrom=${date.from || ''}&dateTo=${date.to || ''}&project=${project || ''}&sort=${sort || ''}`
      );
      // console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getProFolioDetails = createAsyncThunk(
  'portfolio/single',
  async ({ portFolioId, dispatch }) => {
    try {
      // console.log('ID:', portFolioId);
      const response = await get(`/portfolio/admin/${portFolioId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const updateProFolioDetails = createAsyncThunk(
  'portfolio/update',
  async ({ state, portFolioId, dispatch, router }) => {
    try {
      const URL = `/portfolio/admin/${portFolioId}`;

      const response = await put(URL, state);
      if (response) {
        router.push({
          pathname: paths.dashboard.portfolios,
          query: {},
        });
        dispatch(activeSnack({ type: 'success', message: 'ProFolio updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const deleteProFolio = createAsyncThunk(
  'portfolio/delete',
  async ({ portFolioId, dispatch }) => {
    try {
      const response = await del(`/portfolio/admin/${portFolioId}`);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'ProFolio deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
